import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  DialogTitle,
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { Label } from "semantic-ui-react";
import Pagination from "@material-ui/lab/Pagination";
import ConfirmDialog from "../common/confirmDialog/ConfirmDialog";
import api from "../../api";
import utils from "../../utils/utils";
import {
  Role,
  DocumentTypes,
  AgreementStatus,
  RenewalStatus,
} from "../../enums/enums";
import AgreementsTableFilter from "./components/Table/AgreementsTableFilter";
import AgreementsTable from "./components/Table/AgreementsTable";
import AgreementView from "./AgreementView";
import { saveAs } from "file-saver";
import moment from "moment";
import { isDate } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Agreement({ setIsLoading, setDataToast }) {
  let navigate = useNavigate();
  const [dataTable, setDataTable] = useState();
  const [isSearching, setIsSearching] = useState(false);
  const [isAdmin, setIsAdmin] = useState();
  const itemsPerPage = 10;
  const [totalRecords, setTotalRecords] = useState();
  const [paginationData, setPaginationData] = useState({
    amount: 0,
    currentPage: 1,
  });
  const [filterForm, setFilterForm] = useState({
    agreementNumber: undefined,
    documentType: undefined,
    documentNumber: undefined,
    agreementStatus: undefined,
    companyId: undefined,
    dateFrom: undefined,
    dateTo: undefined,
  });
  const [viewData, setViewData] = useState({
    id: undefined,
    productName: "",
    billingId: undefined,
    saleId: undefined,
    externalSalesChannel: undefined,
    productType: "",
    customer: {
      name: "",
      lastName: "",
      businessName: "",
      isCompany: false,
      documentTypeId: "",
      documentTypeName: "",
      documentNumber: "",
      birthDate: "",
      email: "",
      phone: "",
      altPhone: "",
      stateId: "",
      stateName: "",
      cityId: "",
      cityName: "",
      address: "",
      addressNumber: "",
      department: "",
      departmentFloor: "",
    },
    billing: {
      name: "",
      lastName: "",
      businessName: "",
      isCompany: false,
      documentTypeId: "",
      documentTypeName: "",
      documentNumber: "",
      birthDate: "",
      email: "",
      phone: "",
      altPhone: "",
      stateName: "",
      cityName: "",
      address: "",
      addressNumber: "",
      department: "",
      departmentFloor: "",
    },
    payment: {
      typeName: "",
      number: "",
      type: "",
    },
    sale: {
      plateNumber: "",
      brandName: "",
      modelName: "",
      fabricationYear: "",
      colorName: "",
      vehicleTypeName: "",
    },
  });
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: undefined,
  });
  const [reasonCancel, setReasonCancel] = useState();
  const [
    sendMailTermsAndConditionsDialog,
    setSendMailTermsAndConditionsDialog,
  ] = useState({
    open: false,
    id: undefined,
    email: undefined,
  });
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    id: undefined,
  });

  const [cancelRenewalDialog, setCancelRenewalDialog] = useState({
    open: false,
    id: undefined,
  });

  //Lists
  const [documentTypesList, setDocumentTypesList] = useState();
  const [statesList, setStatesList] = useState();
  const [agreementStatesList, setAgreementStatesList] = useState();
  const [companiesList, setCompaniesList] = useState();
  const [reasonCancelList, setReasonCancelList] = useState();

  const { decoded } = useSelector((state) => state.authReducer);

  function search() {
    reloadData(1, itemsPerPage, true);
  }

  function alertMessage(text) {
    setDataToast({
      active: true,
      message: text,
      type: "error",
    });
  }

  const changePage = (event, value) => {
    reloadData(value, itemsPerPage, false);
  };

  function reloadData(page, pageSize, reloadPages) {
    setIsSearching(true);
    setIsLoading(true);
    let dateFrom;
    let dateTo;
    if (isAdmin) {
      if (isDate(filterForm.dateFrom)) {
        dateFrom = filterForm.dateFrom.toISOString().slice(0, 10);
      }

      if (isDate(filterForm.dateTo)) {
        dateTo = filterForm.dateTo.toISOString().slice(0, 10);
      }
    }

    api
      .getAgreements(
        filterForm.agreementNumber,
        filterForm.documentType,
        filterForm.documentNumber,
        filterForm.agreementStatus,
        filterForm.companyId,
        page,
        pageSize,
        reloadPages,
        dateFrom,
        dateTo
      )
      .then((res) => {
        let data = res.data;
        let currentPage = page;
        let amount = paginationData.amount;

        if (reloadPages) {
          if (currentPage !== 1) currentPage = 1;
          amount = Math.ceil(data.cantidad / itemsPerPage);
        }

        setPaginationData({
          amount: amount,
          currentPage: currentPage,
        });
        setTotalRecords(res.data.cantidad);

        let list = [];
        data.resultado.forEach((item) => {
          let name = item.cliente.esEmpresa
            ? item.cliente.razonSocial
            : item.cliente.nombre + " " + item.cliente.apellido;
          list.push({
            number: item.contratoId,
            customer: name,
            product: item.producto,
            compania: item.compania,
            documentNumber: item.cliente.numeroDocumento,
            status: item.numeroEstadoPago,
            email: item.cliente.email,
            confirmedDate: item.fechaConfirmacion,
            firstAgreementDate: item.fechaPrimerContrato,
            expirationDate: item.fechaCaducidad,
            renewalStatus: item.estadoRenovacion,
            cancellationDate: item.fechaCancelacion,
            externalSalesChannel: item.canalDeVentaExterno,
          });
        });

        setDataTable(list);
        setIsSearching(false);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsSearching(false);
        setIsLoading(false);
        if (err.response && Array.isArray(err.response.data.errores)) {
          err.response.data.errores.map((message) => {
            shortError(message);
          });
        } else {
          shortError("Ocurrio un error");
        }
      });
  }

  const closePreSendMailTermsAndConditionsDialog = () => {
    setSendMailTermsAndConditionsDialog({
      ...sendMailTermsAndConditionsDialog,
      open: false,
    });
  };

  function preResendMailAgreement(id, email) {
    setSendMailTermsAndConditionsDialog({ open: true, id: id, email: email });
  }

  function preCancelRenewalAgreement(id) {
    setCancelRenewalDialog({ open: true, id: id });
  }

  const closePreCancelRenewalDialog = () => {
    setReasonCancel(false);
    setCancelRenewalDialog({ ...cancelRenewalDialog, open: false });
  };

  function cancelRenewalAgreement(id) {
    closePreCancelRenewalDialog();
    setIsLoading(true);
    api
      .cancelRenewal(id, reasonCancel)
      .then((res) => {
        let newDataTable = [];
        dataTable.forEach((data) => {
          if (data.number === id) {
            data.renewalStatus = RenewalStatus.Disabled;
          }

          newDataTable.push(data);
        });

        setDataTable(newDataTable);
        setIsLoading(false);
        utils.alertSuccess(
          "Contrato N° " + id,
          "Renovación dada de baja correctamente."
        );
      })
      .catch((err) => {
        setIsLoading(false);
        shortError(err.response.data.errores ?? "Ocurrió un error.");
      });
  }

  const closePreConfirmDialog = () => {
    setConfirmDialog({ ...confirmDialog, open: false });
  };

  const preConfirmAgreement = (id) => {
    setConfirmDialog({ open: true, id: id });
  };

  function confirmAgreement(id) {
    closePreConfirmDialog();
    setIsLoading(true);
    api
      .getAgreementSecurity(id)
      .then((res) => {
        let security = {
          hash: res.data.hash,
          codigo: res.data.codigoValidacion,
        };
        api
          .confirmAgreement(id, security, res.data.hash)
          .then((res) => {
            let newDataTable = [];
            dataTable.forEach((agreement) => {
              if (agreement.number === id) {
                agreement.status = 2;
              }
              newDataTable.push(agreement);
            });

            setDataTable(newDataTable);
            setIsLoading(false);
            utils.alertSuccess("Contrato N° " + id, res.data.message);
          })
          .catch((err) => {
            setIsLoading(false);
            if (err.response.data.errores) {
              utils.alertError("Contrato N° " + id, err.response.data.errores);
            } else {
              shortError("Ocurrió un error");
            }
          });
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.data.errores) {
          utils.alertError("Contrato N° " + id, err.response.data.errores);
        } else {
          shortError("Ocurrió un error");
        }
      });
  }

  function sendMailTermsAndConditionsAgreement(id) {
    closePreSendMailTermsAndConditionsDialog();
    setIsLoading(true);
    api
      .sendMailTermsAndConditions(id)
      .then((res) => {
        setIsLoading(false);
        utils.alertSuccess("Términos y Condiciones", "Enviado correctamente.");
      })
      .catch((err) => {
        setIsLoading(false);
        if (Array.isArray(err.response.data.errores)) {
          err.response.data.errores.map((message) => {
            shortError(message);
          });
        } else {
          shortError("Ocurrio un error");
        }
      });
  }

  function shortError(message) {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  }

  const handleClosePreDelete = () => {
    setReasonCancel(false);
    setDeleteDialog({ ...deleteDialog, open: false });
  };

  const preDelete = (id) => {
    setDeleteDialog({ open: true, id: id });
  };

  function deleteAgreement(id) {
    handleClosePreDelete();
    setIsLoading(true);
    api
      .deleteAgreement(id, reasonCancel)
      .then((res) => {
        let newDataTable = [];
        dataTable.forEach((data) => {
          if (data.number === id) {
            data.status = AgreementStatus.Canceled.Id;
          }

          newDataTable.push(data);
        });

        setDataTable(newDataTable);
        setIsLoading(false);
        utils.alertSuccess(
          "Contrato N° " + id,
          "Contrato dado de baja correctamente."
        );
      })
      .catch((err) => {
        setIsLoading(false);
        shortError(err.response.data.errores ?? "Ocurrió un error.");
      });
  }

  function viewAgreement(id) {
    setIsLoading(true);
    api
      .getAgreementById(id)
      .then((res) => {
        let data = res.data;
        let agreement = viewData;
        let cliente = data.cliente;
        agreement.id = data.id;
        agreement.productName = data.producto.nombre;
        agreement.externalSalesChannel = data.externalSalesChannel;
        agreement.customer = {
          name: cliente.nombre,
          lastName: cliente.apellido,
          businessName: cliente.razonSocial,
          isCompany: cliente.esEmpresa,
          documentTypeId: cliente.tipoDocumentoId,
          documentTypeName: utils.searchTextInList(
            documentTypesList,
            cliente.tipoDocumentoId
          ),
          birthDate: cliente.fechaNacimiento,
          email: cliente.email,
          phone: cliente.telefonoMovil,
          altPhone: cliente.telefonoAlternativo,
          stateName: cliente.provinciaNombre,
          cityId: cliente.localidadId,
          cityName: cliente.localidadNombre,
          address: cliente.direccion,
          addressNumber: cliente.numeroDireccion,
          department: cliente.departamento,
          departmentFloor: cliente.departamentoPiso,
          documentNumber: cliente.numeroDocumento,
        };

        let billing = data.facturacion;
        if (data.facturacionId !== null) {
          agreement.billingId = data.facturacionId;
          agreement.billing = {
            name: billing.nombre,
            lastName: billing.apellido,
            businessName: billing.razonSocial,
            isCompany: billing.esEmpresa,
            documentNumber: billing.numeroDocumento,
            documentTypeId: billing.tipoDocumentoId,
            documentTypeName: utils.searchTextInList(
              documentTypesList,
              billing.tipoDocumentoId
            ),
            birthDate: billing.fechaNacimiento,
            email: billing.email,
            phone: billing.telefonoMovil,
            altPhone: billing.telefonoAlternativo,
            stateName: billing.provinciaNombre,
            cityName: billing.localidadNombre,
            address: billing.direccion,
            addressNumber: billing.numeroDireccion,
            department: billing.departamento,
            departmentFloor: billing.departamentoPiso,
          };
        }

        agreement.payment = {
          typeName: data.medioDePago.nombre,
          number: data.medioDePago.numeroTarjeta
            ? data.medioDePago.numeroTarjeta
            : data.medioDePago.numeroCBU,
          type: data.medioDePago.tipo,
        };
        if (data.ventaId) {
          agreement.saleId = data.ventaId;
          agreement.sale = {
            plateNumber: data.venta.patente,
            brandName: data.venta.marca,
            modelName: data.venta.modelo,
            fabricationYear: data.venta.anioFabricacion,
            mileage: data.venta.kilometraje,
            colorName: data.venta.color,
            vehicleTypeName: data.venta.tipoVehiculo,
          };
        }
        setViewData(agreement);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        if (Array.isArray(err.response.data.errores)) {
          err.response.data.errores.forEach((message) => {
            shortError(message ?? "Ocurrió un error.");
          });
        } else {
          shortError(err.response.data.errores);
        }
      });
  }

  const returnView = () => {
    setViewData({ ...viewData, id: undefined, saleId: undefined });
  };

  function ExportarExcel() {
    let agreementId = filterForm.agreementNumber;
    let documentTypeId = filterForm.documentType;
    let documentNumber = filterForm.documentNumber;
    let status = filterForm.agreementStatus;
    let companyId = filterForm.companyId;
    let dateFrom = isDate(filterForm.dateFrom)
      ? moment(filterForm.dateFrom).format("YYYY-MM-DD")
      : undefined;
    let dateTo = isDate(filterForm.dateTo)
      ? moment(filterForm.dateTo).format("YYYY-MM-DD")
      : undefined;

    setIsLoading(true);
    api
      .getAgreementExcel(
        agreementId,
        documentTypeId,
        documentNumber,
        status,
        companyId,
        dateFrom,
        dateTo
      )
      .then((res) => {
        let extension = "xlsx";
        let tempFileName = "Contratos";
        let fileName = `${tempFileName}.${extension}`;

        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
        saveAs(blob, fileName);
        reloadData(1, itemsPerPage, true);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      });
  }

  useEffect(() => {
    setIsLoading(true);
    let role = decoded.role;

    setIsAdmin(role === Role.AdminComercial ?? false);

    if (role === Role.AdminComercial) {
      Promise.all([
        api.getDocumentTypes(),
        api.getAgreementsStates(),
        api.getStates(),
        api.getReasonsCancelList(),
        api.getCompanies(),
      ])
        .then((res) => {
          setDocumentTypesList(utils.setDataInList(res[0].data));

          let documentType;
          switch (role) {
            case Role.InternalSeller:
            case Role.ExternalSeller:
              documentType = DocumentTypes.DNI;
              break;
            default:
              documentType = "";
              break;
          }

          setFilterForm({ ...filterForm, documentType: documentType });
          setAgreementStatesList(utils.setDataInList(res[1].data));
          setStatesList(utils.setDataInList(res[2].data));
          setReasonCancelList(utils.setDataInList(res[3].data));
          setCompaniesList(utils.setDataInList(res[4].data));
        })
        .catch(() => shortError("Ocurrió un error"));
    } else {
      Promise.all([
        api.getDocumentTypes(),
        api.getAgreementsStates(),
        api.getStates(),
        api.getReasonsCancelList(),
      ])
        .then((res) => {
          setDocumentTypesList(utils.setDataInList(res[0].data));

          let documentType;
          switch (role) {
            case Role.InternalSeller:
            case Role.ExternalSeller:
              documentType = DocumentTypes.DNI;
              break;
            default:
              documentType = "";
              break;
          }

          setFilterForm({ ...filterForm, documentType: documentType });
          setAgreementStatesList(utils.setDataInList(res[1].data));
          setStatesList(utils.setDataInList(res[2].data));
          setReasonCancelList(utils.setDataInList(res[3].data));
        })
        .catch(() => shortError("Ocurrió un error"));
    }
    setIsLoading(false);
  }, []);

  return (
    <>
      <div className={viewData.id === undefined ? "" : "c-none"}>
        <Paper className="c-grid" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid className="c-grid-header" container spacing={1}>
                <Grid item xs={6}>
                  <h2>CONTRATOS</h2>
                </Grid>
                {!isAdmin && (
                  <Grid item xs={6}>
                    <Button
                      onClick={() => navigate("/contrato/crear")}
                      className="c-grid-btn c-btn-success"
                      variant="contained"
                    >
                      Crear nuevo
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid className="c-grid-header-filter c-mt-10" item md={12}>
              {isAdmin !== undefined &&
                documentTypesList &&
                agreementStatesList && (
                  <AgreementsTableFilter
                    IsSearching={isSearching}
                    FilterForm={filterForm}
                    SetFilterForm={setFilterForm}
                    SubmitFunction={search}
                    DocumentTypesList={documentTypesList}
                    AgreementStatesList={agreementStatesList}
                    CompaniesList={companiesList}
                    IsAdmin={isAdmin}
                    setDataToast={setDataToast}
                  />
                )}
            </Grid>
          </Grid>
        </Paper>

        {dataTable && dataTable.length > 0 && (
          <Paper className="c-mt-20 c-grid-results" elevation={3}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6} className={!isAdmin ? "c-mb-5" : "c-mb-0"}>
                    <Label
                      style={{
                        marginLeft: "5px",
                      }}
                      className="c-total-success"
                    >
                      Cantidad de registros en la búsqueda: {totalRecords}
                    </Label>
                  </Grid>
                  {isAdmin && (
                    <Grid
                      item
                      xs={6}
                      style={{ textAlign: "right", marginBottom: "5px" }}
                    >
                      <Button
                        className="c-btn-success"
                        color="primary"
                        onClick={ExportarExcel}
                        variant="contained"
                      >
                        Exportar
                      </Button>
                    </Grid>
                  )}
                </Grid>
                <AgreementsTable
                  Data={dataTable}
                  ConfirmFunction={preConfirmAgreement}
                  DeleteFunction={preDelete}
                  EmailFunction={preResendMailAgreement}
                  CancelRenewal={preCancelRenewalAgreement}
                  ViewFunction={viewAgreement}
                  IsAdmin={isAdmin}
                />
              </Grid>
              <Grid
                item
                xs={12}
                container
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Pagination
                  className="c-pagination"
                  onChange={changePage}
                  page={paginationData.currentPage}
                  count={paginationData.amount > 1 ? paginationData.amount : 0}
                  shape="rounded"
                />
              </Grid>
            </Grid>
          </Paper>
        )}

        {dataTable && dataTable.length === 0 && (
          <Paper className="c-mt-20" elevation={3}>
            <Grid container spacing={1}>
              <Grid item xs={12} className="c-text-center">
                <h5>No se encontraron resultados.</h5>
              </Grid>
            </Grid>
          </Paper>
        )}

        {deleteDialog !== undefined && (
          <Dialog open={deleteDialog.open} onClose={handleClosePreDelete}>
            <DialogTitle className="c-text-center">
              ¿Desea dar de baja el contrato N° {deleteDialog.id}?
            </DialogTitle>
            <DialogContent>
              <FormControl variant="outlined" fullWidth={true} size="small">
                <InputLabel>Motivo de baja</InputLabel>
                <Select
                  variant="outlined"
                  onChange={(e) => setReasonCancel(e.target.value)}
                  label="Motivo de baja"
                >
                  {reasonCancelList &&
                    reasonCancelList.map((item) => (
                      <MenuItem key={item.key} value={item.value}>
                        {item.text}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button
                className="c-btn-cancel"
                color="primary"
                onClick={handleClosePreDelete}
              >
                Cancelar
              </Button>
              <Button
                className="c-btn-success"
                color="primary"
                autoFocus
                disabled={!reasonCancel}
                onClick={() => deleteAgreement(deleteDialog.id)}
              >
                Aceptar
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {cancelRenewalDialog !== undefined && (
          <Dialog
            open={cancelRenewalDialog.open}
            onClose={closePreCancelRenewalDialog}
          >
            <DialogTitle className="c-text-center">
              ¿Desea dar de baja la renovación del contrato N°{" "}
              {cancelRenewalDialog.id}?
            </DialogTitle>
            <DialogContent>
              <FormControl variant="outlined" fullWidth={true} size="small">
                <InputLabel>Motivo de baja</InputLabel>
                <Select
                  variant="outlined"
                  onChange={(e) => setReasonCancel(e.target.value)}
                  label="Motivo de baja"
                >
                  {reasonCancelList &&
                    reasonCancelList.map((item) => (
                      <MenuItem key={item.key} value={item.value}>
                        {item.text}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button
                className="c-btn-cancel"
                color="primary"
                onClick={closePreCancelRenewalDialog}
              >
                Cancelar
              </Button>
              <Button
                className="c-btn-success"
                color="primary"
                autoFocus
                disabled={!reasonCancel}
                onClick={() => cancelRenewalAgreement(cancelRenewalDialog.id)}
              >
                Aceptar
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {sendMailTermsAndConditionsDialog !== undefined && (
          <ConfirmDialog
            open={sendMailTermsAndConditionsDialog.open}
            message={
              "Se enviará los términos y condiciones al correo " +
              sendMailTermsAndConditionsDialog.email
            }
            cancelAction={closePreSendMailTermsAndConditionsDialog}
            confirmAction={() =>
              sendMailTermsAndConditionsAgreement(
                sendMailTermsAndConditionsDialog.id
              )
            }
          />
        )}

        <ConfirmDialog
          open={confirmDialog.open}
          message={"¿Desea confirmar el contrato N° " + confirmDialog.id + " ?"}
          cancelAction={closePreConfirmDialog}
          confirmAction={() => confirmAgreement(confirmDialog.id)}
        />
      </div>

      <div className={viewData.id === undefined ? "c-none" : ""}>
        <AgreementView ViewData={viewData} ReturnFunction={returnView} />
      </div>
    </>
  );
}
